module.exports = __webpack_public_path__ + "static/media/brand1.3d0db210.png";